/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Prepare_Item_3Inputs */

const en_how_we_work_prepare_item_3 = /** @type {(inputs: How_We_Work_Prepare_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The part you wish worked differently.`)
};

const lv_how_we_work_prepare_item_3 = /** @type {(inputs: How_We_Work_Prepare_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To daļu, kurai gribētos citādu risinājumu.`)
};

/**
* | output |
* | --- |
* | "The part you wish worked differently." |
*
* @param {How_We_Work_Prepare_Item_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_prepare_item_3 = /** @type {((inputs?: How_We_Work_Prepare_Item_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Prepare_Item_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_prepare_item_3(inputs)
	return en_how_we_work_prepare_item_3(inputs)
});